import { render, staticRenderFns } from "./vistaContratoDeudor.vue?vue&type=template&id=24706d2e&scoped=true"
import script from "./vistaContratoDeudor.vue?vue&type=script&lang=js"
export * from "./vistaContratoDeudor.vue?vue&type=script&lang=js"
import style0 from "./vistaContratoDeudor.vue?vue&type=style&index=0&id=24706d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24706d2e",
  null
  
)

export default component.exports